import { render, staticRenderFns } from "./add-wholesaler.vue?vue&type=template&id=7bab110a&scoped=true"
import script from "./add-wholesaler.vue?vue&type=script&lang=js"
export * from "./add-wholesaler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bab110a",
  null
  
)

export default component.exports